<template>
  <el-dialog
    title="视频上传"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="closeDialog"
  >
    <div class="video-upload-con">
      <el-form ref="form" :model="contentInfo" label-width="5rem">
        <el-form-item label="曲速" required>
          <el-input-number v-model="contentInfo.speed" size="small" style="width: 10rem !important"></el-input-number>
        </el-form-item>
      </el-form>
      <div>
        <input type="file" id="fileUpload" @change="fileChange($event)" />
        <p>仅支持MP4视频文件(上传停止可再次点击按钮续传)</p>
      </div>
      <div>
        <el-button
          class="video-upload"
          @click="addUpload"
          :disabled="startUploadFlag"
          type="primary"
          size="small"
          >开始上传</el-button>
        <span class="progress">上传进度: <i id="auth-progress">{{ authProgress }}</i> %</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "DialogVideo",
  /**
   * contentInfo 内容
   * */
  props: ["contentInfo"],
  components: {},
  data() {
    return {
      dialogVisible: true,
      // 视频上传 ---------------------------------
      // 视频上传对象
      auth_uploader: "",
      // 上传视频文件对象
      auth_file: null,
      // 开始上传按钮控制
      startUploadFlag: true,
      //视频上传的进度，
      authProgress: 0,
      // 视频上传凭证返回结果
      authResult: "",
      // 播放按钮控制  成功就会打开  可以用来判断视频是否上传
      playFlag: false,
      //播放按钮可点击控制
      playBtnDisable: true,
      // 可播放计数
      playCount: false,
      // 计数控制
      usePlay: false,
      // 播放容器控制  获取播放凭证成功就会显示
      videoFlag: false,
    };
  },
  created() {
    this.$set(this.contentInfo, "parentResourceId", this.contentInfo.id);
    console.log(this.contentInfo);
    // 2022-10-12 逻辑修改，增加一层曲速子课程
  },
  methods: {
    //视频文件变换时触发  添加移除都会触发
    fileChange(file) {
      // 文件变换时 上传按钮禁用  类型正确再打开
      this.startUploadFlag = true;

      // 关闭播放容器
      this.playFlag = false;
      // 关闭视频容器
      this.videoFlag = false;
      //  关闭计数
      this.usePlay = false;
      // 按钮不可点击
      this.playBtnDisable = true;

      this.auth_file = file.target.files[0];
      if (!this.auth_file) {
        return this.$message.error("请先选择需要上传的文件!");
      }
      //

      let userData = '{"Vod":{}}';

      if (this.auth_uploader) {
        // 停止上传toLowerCase
        this.auth_uploader.stopUpload();
        // 进度置零
        this.authProgress = 0;
      }
      // console.log('jhsdkajshdkasjh');
      //创建对象
      this.auth_uploader = this.getUpload();
      // 添加文件
      this.auth_uploader.addFile(this.auth_file, null, null, null, userData);
    },

    // 获取upload对象  声明一个AliyunUpload.Vod初始化回调
    getUpload() {
      let that = this;
      let uploader = new AliyunUpload.Vod({
        //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
        userId: "1689030746142927",
        region: "cn-shanghai",
        //分片大小默认1M，不能小于100K
        partSize: 1048576,
        //并行上传分片个数，默认5
        parallel: 5,
        //网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        //网络原因失败时，重新上传间隔时间，默认为2秒
        retryDuration: 2,
        //是否上报上传日志到点播，默认为true
        enableUploadProgress: true,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          console.log("视频添加成功: " + uploadInfo.file.type);

          if (uploadInfo.file.type === "video/mp4") {
            // 开启文件上传
            that.startUploadFlag = false;
          } else {
            return that.$message.error("仅支持MP4视频文件");
          }
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          console.log("开始上传: " + uploadInfo.file.name);

          let fileExt = uploadInfo.file.name.split(".");
          fileExt = fileExt[fileExt.length - 1];
          if (uploadInfo.videoId) {
            console.log("断点续传------------------------------");
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口  GET /1.0/content/upload/video/auth/refresh.json
            that.$api
              .get("/content/upload/video/auth/refresh.json", {
                videoId: uploadInfo.videoId,
              })
              .then(
                (success) => {
                  // 保存结果
                  that.authResult = success.data;
                  //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                  let uploadAuth = success.data.uploadAuth;
                  // let videoId = success.data.videoId;
                  let uploadAddress = success.data.uploadAddress;
                  uploader.setUploadAuthAndAddress(
                    uploadInfo,
                    uploadAuth,
                    uploadAddress
                  );
                },
                (error) => {
                  // 刷新不到凭证就重新获取
                  let params = {
                    // 在文件变动的时候这些字段有值
                    cid: that.contentInfo.categoryId,
                    title: that.contentInfo.title,
                    fileExt: fileExt,
                  };
                  that.$api
                    .get("/content/upload/video/auth.json", params)
                    .then(
                      (success) => {
                        // 保存结果
                        that.authResult = success.data;
                        //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                        let uploadAuth = success.data.uploadAuth;
                        let videoId = success.data.videoId;
                        let uploadAddress = success.data.uploadAddress;
                        uploader.setUploadAuthAndAddress(
                          uploadInfo,
                          uploadAuth,
                          uploadAddress,
                          videoId
                        );
                      },
                      (error) => {
                        that.$message.error(error.msg);
                      }
                    )
                    .catch((err) => {
                      console.log(err);
                      that.$message.error("凭证获取异常！");
                    });
                }
              )
              .catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
          } else {
            // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口
            let params = {
              // 在文件变动的时候这些字段有值
              cid: that.contentInfo.categoryId,
              title: that.contentInfo.title,
              fileExt: fileExt,
            };
            that.$api
              .get("/content/upload/video/auth.json", params)
              .then(
                (success) => {
                  // 保存结果
                  that.authResult = success.data;
                  //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                  let uploadAuth = success.data.uploadAuth;
                  let videoId = success.data.videoId;
                  let uploadAddress = success.data.uploadAddress;
                  uploader.setUploadAuthAndAddress(
                    uploadInfo,
                    uploadAuth,
                    uploadAddress,
                    videoId
                  );
                },
                (error) => {
                  that.$message.error(error.msg);
                }
              )
              .catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
          }
        },

        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          that.auth_uploader = null;
          that.auth_file = null;

          // 显示播放按钮
          that.playFlag = true;
          let param = {
            id: that.contentInfo.id,
            videoId: that.authResult.videoId,
          };
          console.log(param);
          let res = that.$api.post("/content/video/update.json", param);
          res
            .then(
              (success) => {
                // 保存结果
                that.$message({
                  message: "视频上传成功！",
                  type: "success",
                });
                that.$emit("closeDialog");
              },
              (error) => {
                that.$message.error(error.msg);
              }
            )
            .catch((err) => {
              console.log(err);
              that.$message.error("视频已上传，但绑定内容异常！");
            });

          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log(
            "上传失败:" +
              uploadInfo.file.name +
              ",code:" +
              code +
              ", message:" +
              message
          );
          if (uploadInfo.videoId) {
            console.log("上传失败断点续传------------------------------");
            console.log(uploadInfo.videoId);
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口  GET /1.0/content/upload/video/auth/refresh.json
            that.$api
              .get("/content/upload/video/auth/refresh.json", {
                videoId: uploadInfo.videoId,
              })
              .then(
                (success) => {
                  that.authResult = success.data;
                  //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                  let uploadAuth = success.data.uploadAuth;
                  let uploadAddress = success.data.uploadAddress;
                  uploader.setUploadAuthAndAddress(
                    uploadInfo,
                    uploadAuth,
                    uploadAddress
                  );
                },
                (error) => {
                  // that.$message.error(error.msg)
                  // 刷新不到凭证就重新获取
                  let fileExt = uploadInfo.file.name.split(".");
                  fileExt = fileExt[fileExt.length - 1];
                  let params = {
                    // 在文件变动的时候这些字段有值
                    cid: that.contentInfo.categoryId,
                    title: that.contentInfo.title,
                    fileExt: fileExt,
                  };
                  that.$api
                    .get("/content/upload/video/auth.json", params)
                    .then(
                      (success) => {
                        // 保存结果
                        that.authResult = success.data;
                        //  设置凭证   从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
                        let uploadAuth = success.data.uploadAuth;
                        let videoId = success.data.videoId;
                        let uploadAddress = success.data.uploadAddress;
                        uploader.setUploadAuthAndAddress(
                          uploadInfo,
                          uploadAuth,
                          uploadAddress,
                          videoId
                        );
                      },
                      (error) => {
                        that.$message.error(error.msg);
                      }
                    )
                    .catch((err) => {
                      console.log(err);
                      that.$message.error("凭证获取异常！");
                    });
                }
              )
              .catch((err) => {
                console.log(err);
                that.$message.error("凭证获取异常！");
              });
          }
        },
        // 文件上传进度，单位：字节
        onUploadProgress: function (uploadInfo, totalSize, loadedPercent) {
          let authProgress = Math.ceil(loadedPercent * 100);
          that.authProgress = authProgress;
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          //实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
          let params = {
            videoId: uploadInfo.videoId,
          };
          let res = that.$api.get(
            "/content/upload/video/auth/refresh.json",
            params
          );
          res
            .then(
              (success) => {
                // 保存结果
                that.authResult = success.data;
                //从点播服务刷新的uploadAuth,设置到SDK里
                let uploadAuth = success.data.uploadAuth;
                uploader.resumeUploadWithAuth(uploadAuth);
              },
              (error) => {
                that.$message.error(error.msg);
              }
            )
            .catch((err) => {
              that.$message.error("凭证获取异常！");
            });
        },
        //全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log("上传完成！");
        },
      });
      return uploader;
    },

    // 视频点击上传
    addUpload() {
      // if (!this.add_info.cid) {
      //     return this.$message.error("请先选择章节！");
      // }
      if (!this.auth_file) {
        return this.$message.error("请先选择文件！");
      }
      if (!this.contentInfo.speed) {
        return this.$message.error("请先输入速度！");
      }
      // 上传对象存在调用 startUpload 方法, 开始上传
      if (this.auth_uploader !== null) {
        let res = this.$api.post("/content/add.json", this.contentInfo);
        res.then((success) => {
          // 返回视频编号
          this.contentId = success.data;
          this.auth_uploader.startUpload();
        }, (error) => {
          this.$message.error(error.msg);
        }).catch((err) => {
          this.$message.error("内容生成异常，无法添加视频！");
        });
      }
    },

    //
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped>
.video-upload-con {
  width: 100%;
  padding-left: 2rem;
}
.video-upload {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DialogVideo.vue